// Access denied modal messages — role errors and no-license errors shown to user on login.
// Functions accept email string (may be empty); prefix is omitted when email unavailable.

export const LOGIN_ERROR_MESSAGES = {
  SESSION_EXPIRED: "Your session could not be renewed. Please log in again.",
  CONNECTION_FAILED: "Login failed. Please check your connection and try again.",
  INVALID_CREDENTIALS: "Invalid credentials, please try again.",
  ACCOUNT_DETAILS_FAILED: "Failed to load account details. Please try again.",
  ACCOUNT_MISMATCH:
    "Please ensure that the user belongs to the selected account and try again.",
};

const withPrefix = (email, msg) => (email ? `You are logged in as ${email}. ${msg}` : msg);

export const ROLE_ERROR_MESSAGES = {
  SERVICE_ERROR: (email) =>
    withPrefix(
      email,
      "Your 5G Video Insights role could not be verified due to a service error. Please try again later or contact support."
    ),
  NO_ROLE_ASSIGNED: (email) =>
    withPrefix(
      email,
      "Your account has no role assigned for 5G Video Insights. Please contact your administrator."
    ),
};

export const NO_LICENSE_MESSAGES = {
  WITH_ACCOUNT: (email, ecpdDisplay, billingAccountId) =>
    withPrefix(
      email,
      `Your 5G Video Insights license is inactive or expired for ECPD Account: ${ecpdDisplay} (Billing: ${billingAccountId}). Please check your settings or contact support.`
    ),
  WITHOUT_ACCOUNT: (email) =>
    withPrefix(
      email,
      "Your 5G Video Insights license is inactive or expired. Please check your settings or contact support."
    ),
};
